import { render, staticRenderFns } from "./PagePoliticaCookiesCat.vue?vue&type=template&id=44f0d6a8&"
import script from "./PagePoliticaCookiesCat.vue?vue&type=script&lang=js&"
export * from "./PagePoliticaCookiesCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports